<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" @click="hideModal">&times;</button>
            <h4 class="modal-title">Zapisz szablon</h4>
        </div>
        <div class="modal-body">
            <div class="alert alert-danger fade in" v-if="hasError">
                Szablon o tej nazwie już istnieje.
            </div>

            <div class="form-group">
                <div class="col-md-4">
                    <label>Nazwa jadłospisu</label>
                </div>
                <div class="col-md-8">
                    <input class="form-control"
                           v-model="name"
                           placeholder="Nazwa pod jaką zapiszesz szablon, minimum 3 znaki"
                    >
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" @click="hideModal">Zamknij</button>
            <button type="submit" class="btn btn-success"
                    @click="save"
                    :class="{'btn-success': !hasError, 'btn-danger': hasError}"
                    :disabled="name.length < 3"
            >
                Zapisz szablon
            </button>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';

    export default {
    data() {
      return {
        name: '',
        error: null,
      };
    },
    computed: {
      ...mapState(['menu']),
      hasError() {
        return this.error !== null;
      },
    },
    methods: {
      ...mapMutations([
        'hideModal',
      ]),
      save() {
        const vm = this;
        this.error = null;

        axios.post('/menus/' + this.menu.id + '/export', {
          title: this.name,
          tags: this.tags
        }).then(() => {
          vm.$toasted.global.success({ message: 'Szablon został zapisany!' });
          vm.hideModal();
        }).catch((error) => {
          this.sentryCaptureException(error);
          vm.error = error;
          vm.$toasted.global.error({ message: 'Szablon nie został zapisany!' });
        });

      },
    },
  };
</script>

<style scoped>

</style>
